import actionTypes from '../../action-types'

export default (page, filter) => ({
  type: actionTypes.SESSIONS.FETCH_SESSIONS,
  meta: {
    page,
    filter,
  },
})
